import styled from 'styled-components';

export default {
  StyledEmptyState: styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: ${props => (props.halfHeight ? '50%' : '100%')};
    width: auto;
    margin: 0 ${({ theme }) => theme.space[4]}px;
    text-align: center;
    font-family: system-ui;
    position: absolute;
    width: fill-available;
    padding: 0 ${({ theme }) => theme.space[11]}px;
  `,

  StyledEmptyStateContent: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  `,

  StyledEmptyStateAction: styled.div`
    display: flex;
    margin-top: ${({ theme }) => theme.space[6]}px;
    width: 100%;
    justify-content: center;
  `,
};
